import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Edit, Trash2 } from 'lucide-react';
import { SERVIDOR } from '../../config';
import moment from 'moment/moment';
import axios from 'axios';

const UserTable = () => {
  const initialUsers = [
    { id: 1, name: "Carlos García", email: "carlos@ejemplo.com", date: "2024-12-22", status: "Pendiente", token: "TOKEN123456" },
    { id: 2, name: "Ana Martínez", email: "ana@ejemplo.com", date: "Usuario", status: "Atendida", token: "TOKEN789012" },
    { id: 3, name: "Luis Rodriguez", email: "luis@ejemplo.com", date: "Editor", status: "En Proceso", token: "TOKEN345678" },
  ];

  const fechaActual = moment().format('YYYY-MM-DD')

  const [users, setUsers] = useState(initialUsers);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasValidated, setHasValidated] = useState(false);
  
  const navigate = useNavigate();

  const validarAdmin = async () => {
    if (hasValidated) return; // Evita validaciones múltiples
    
    try {
      const token = localStorage.getItem('adminToken');
      const response = await axios.post(SERVIDOR + '/api/validar-admin', { adminToken: token });
      const data = response.data;

      if (!data.ok) {
        alert('Acceso denegado');
        navigate('/loginAdmin');
      }
      setHasValidated(true);
      
      // Fetch users data only after successful validation
      fetch(SERVIDOR+'/api/tokens2')
        .then(response => response.json())
        .then(data => {
          setUsers(data.tokens);
        });

    } catch (error) {
      console.error('Error al validar acceso:', error);
      navigate('/loginAdmin');
    }
  };

  useEffect(() => {
    validarAdmin();
  }, []);

  const handleStatusChange = (id, newStatus) => {
    setUsers(users.map(user =>
      user.id === id ? { ...user, status: newStatus } : user
    ));

    fetch(SERVIDOR+'/api/token-change/'+id, {
      method: 'PUT',
      body: JSON.stringify({estado: newStatus}) ,
      headers: {
        Accept: "application/json",
        'Content-Type': 'application/json'
      },
    })
    .then((response)=>{
      if(!response.ok){
        alert(response.error)
      }
    })
  };

  const handleDeleteUser = (userId) => {
    const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este token?');
    if (confirmDelete) {
      fetch(SERVIDOR+'/api/tokens/'+userId,{
            method:'delete'
      })
      .then((response =>  response.json()))
      .then((data)=>{
        if(!data.ok){
          alert('ERROR AL ELIMINAR TOKEN ')
        }
        else{
          alert('Token eliminado correctamente')
          setUsers(users.filter(user => user.id !== userId));
        }
      })    
    }
  };

  const filteredUsers = users.filter(user =>
    Object.values(user).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handleGoBack = () => {
    navigate('/AdminUsersPanel');
  };

  if (!hasValidated) {
    return <div className="flex items-center justify-center h-screen">Validando acceso...</div>;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-8 pt-16">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h2 className="text-4xl font-bold text-[#697565] mb-2">
            Gestión de Usuarios
          </h2>
          <p className="text-gray-600">
            Administra y actualiza el estado de los usuarios del sistema
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          <div className="flex items-center justify-between mb-6">
            <div className="relative w-64 flex-grow">
              <input
                type="text"
                placeholder="Buscar usuarios..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full px-4 py-2 pl-10 pr-4 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#697565] focus:border-transparent"
              />
            </div>

            <button
              onClick={handleGoBack}
              className="ml-4 px-4 py-2 text-sm bg-[#697565] text-white font-medium rounded-lg hover:bg-[#566a55] focus:outline-none focus:ring-2 focus:ring-[#697565]/50"
            >
              Regresar
            </button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#697565]/10">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#697565]">Nombre</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#697565]">Email</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#697565]">Vencimiento</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#697565]">Estado</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-[#697565]">Token</th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-[#697565]">Acciones</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredUsers.map((user) => (
                  <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">{user.name}</div>
                    </td>
                    <td className="px-6 py-4 text-sm text-gray-600">{user.email}</td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium ${
                        user.date == fechaActual ? 'bg-[#fcc05f]/80 text-white' :
                        user.date < fechaActual ? 'bg-red-500/80 text-white' :
                        'bg-gray-100 text-gray-800'
                      }`}>
                        {user.date}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <select
                        value={user.status}
                        onChange={(e) => handleStatusChange(user.id, e.target.value)}
                        className="block w-full px-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-[#697565] focus:border-[#697565] bg-white hover:bg-gray-50 transition-colors outline-none"
                      >
                        <option value="Pendiente">Pendiente</option>
                        <option value="En Proceso">En Proceso</option>
                        <option value="Atendida">Atendida</option>
                      </select>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-500 font-mono bg-gray-50 px-2 py-1 rounded">{user.token}</div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <div className="flex justify-center space-x-3">
                        <button
                          onClick={() => handleDeleteUser(user.id)}
                          className="bg-red-500/80 text-white font-semibold py-2 px-2 rounded-lg hover:bg-red-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-red-300 transition duration-300 ease-in-out"
                          title="Eliminar"
                        >
                          Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserTable;